<style scoped>
.charts {
  display: table;
  width: 100%;
  position: relative;
  height: 300px;
}


</style>
<template lang="pug">
.charts
    #linechart
    .emptychart(v-show="emptyOption")
    .loadingchart(v-show="isLoading")
</template>

<script>
/* global _,echarts */
import { lineChartOptionFactory } from './options.js'
import resizeMixin from './resize.mixin.js'
export default {
  mixins: [resizeMixin],
  // todo 为折线图设置 props
  props: {
    height: {
      type: Number,
      default: 300
    },
    legend: Array,
    xAxis: Array,
    series: Array,
    yAxis: Array,
    extendXAxis: Array
  },
  computed: {
    emptyOption: function () {
      return _.isEmpty(this.legend) || _.isEmpty(this.xAxis) ||
        _.isEmpty(this.series)
    },
    finalSeries () {
      return this.series.map((item) => {
        item.data = item.data.map((dataItem) => {
          return _.isNull(dataItem) ? 0 : dataItem
        })
        return item
      })
    },
    isLoading () {
      return this.$store.state.chartLoading
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  updated () { // todo 数据更新的时候重绘折线图，数据为空自定义提示
    if (!_.has(this.chart, ['setOption']) && !this.emptyOption) {
      this.chart = echarts.init(document.getElementById('linechart'),
        null, {height: this.height})
    }
    let option = {
      legendData: this.legend,
      xAxisData: this.xAxis,
      seriesItems: this.finalSeries,
      yAxis: this.yAxis
    }
    if (this.extendXAxis) {
      option = _.assignIn({extendXAxis: this.extendXAxis}, option)
    }
    !this.emptyOption && this.chart.setOption(lineChartOptionFactory(option))
  },
  mounted () {
    if (!this.emptyOption) {
      this.chart = echarts.init(document.getElementById('linechart'),
        null, {height: this.height})
      this.chart.setOption(lineChartOptionFactory({
        legendData: this.legend,
        xAxisData: this.xAxis,
        seriesItems: this.finalSeries,
        yAxis: this.yAxis
      }))
    }
  },
  // 销毁时将loading置为false
  destroyed () {
    this.$store.commit('CHART_LOADING', false)
    this.chart = {}
  }
}
</script>



// WEBPACK FOOTER //
// lineChart.vue?6cacddd1